import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { QueryKey } from "common/enums/query-key";
import { BackendError } from "common/types/errors/backendError";
import { acceptBackgroundCheck } from "services/api/background-check-api.service";
import { notification } from "services/services";

type Variables = { applicationId: string, orderPlanIds: string[] }
export function useAcceptBackgroundCheck(options?: UseMutationOptions<void, AxiosError<BackendError>, Variables, unknown>) {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: ({ applicationId, orderPlanIds }) => acceptBackgroundCheck(applicationId, orderPlanIds),
    onSettled: () => {
      // TODO: Note: check what is going on WHEN we send Accept!!!
      // because we send accept ONLY after successful payment (when renter pay) so maybe there is some dealy????
      queryClient.invalidateQueries({ queryKey: [QueryKey.Offers] }); // BUT here we have query invalidation 
      // in useRenterOffers we set: [QueryKey.Offers, 'renter', params] - so i'm not sure about refetching
      // BUT in cancel offer we also use [QueryKey.Offers] and everything works
    },
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);
      notification.success('Background check has been accepted');
    },
    onError: (e) => {
      notification.error(e?.response?.data?.detail || 'The Background Check has not been accepted');
    },
    ...options,
  });
}
